<!--
Component for adding a button that calls a confirmation dialog if dirtied (formular changed).
If dirty is set to true, will call dialog, otherwise just calls the method instantly.

Very useful for cancel buttons.

Hint: Reference to components can't be called in created-hook, unless running inside of an API call -> later executed
Have to use mounted-hook instead.
 -->
<template>
  <span>
    <BaseButton
        v-if="!dirty"
        color="grey"
        :btn-text="btnText"
        @clickedButton="$emit('clickedButton')"
      />
    <TwoButtonDialog
        v-else
        ref="cancelButton"
        :btn-text="btnText"
        :color="color"
        :dialog-title="dialogTitle"
        :dialog-text="dialogText"
        :button1-text="button1Text"
        :button2-text="button2Text"
        @clickedButton1="$refs.cancelButton.showDialog = false"
        @clickedButton2="$emit('clickedButton')"
        :hide-overlay="hideOverlay"
    />
  </span>
</template>

<script>
import TwoButtonDialog from "./TwoButtonDialog";
import BaseButton from "../Base/BaseButton";

export default {
  name: "DirtyConfirmButtonDialog",
  components: {
    TwoButtonDialog,
    BaseButton
  },
  props: {
    btnText: String,
    color: String,
    dialogTitle: String,
    dialogText: String,
    button1Text: String,
    button2Text: String,
    dataToWatch: Object,
    hideOverlay: Boolean
  },
  data(){
    return {
      dirty: false,
      watchStarted: false,
    }
  },
  methods: {
    setDirty(value) {
      this.dirty = value;
    },
    startWatch(){
      //property information is usually updated at the end, so have to wait for the next tick
      //otherwise would get immediately updated as it jumps from empty to initialize object

      //will also reset the dirty value back to false if called again
      this.$nextTick(() => {
        if(!this.watchStarted) {
          this.$watch('dataToWatch', () => {
            this.dirty = true
          }, {deep: true});
          this.watchStarted = true;
        }
        this.dirty = false;
      });
    }
  }
}

</script>
